/** A teacher's words in the person visit: the teaching profile, its sections and its removal. */
export const teachingCopy = {
  profileLabel: "Teaching profile",
  profileJob: "This person's recorded teaching facts, saved where each is drawn.",
  profileDetail: "Shown to students and teachers in the Faculty directory.",
  facultyRecord: "Faculty record",
  personRecord: "Person record",
  teachingDetails: "Teaching details",
  title_role: "Title",
  specialization: "Specialization",
  training_chain: "Training chain",

  profileRemoved: "No teaching profile now",
  unknownSentence: "We could not confirm removal of the teaching profile. Check its result before trying again.",

  assignLabel: "Teaching assignments",
  assignJob: "The courses this person teaches.",
  noSections: "No teaching assignments recorded.",
  selectedTerm: "In the selected term.",
  noTerm: "No term",
  primary: "Primary",
  coInstructor: "Co-instructor",

  removeLabel: "Remove teaching profile",
  removeJob: "Remove an unused teaching profile.",
  removeDetail: "Teaching history is kept. Use Archive person to remove someone from working lists.",
  removeVerb: "Remove profile",
  removeCap: "When you remove",
  removeEffect: "Remove the teaching profile; sign-in and access stay",
  referPart: "Courses that refer to it",
  noneRefer: "None",
  noneReferSummary: "No course refers to this profile.",
  checkingCourses: "Checking every course assignment.",
  previewUnavailable: "Couldn't check the courses",
  previewUnavailableDetail: "Nothing is removed while the courses are unread.",
  removed: "Removed",
  inUse: "In use",
  unused: "Unused",
  returnRereads: "Return reads People again",
  removeRefused: "Not removed.",
  removeUnknown: "Removing the teaching profile",
  removeCheckNote: "Reads the saved removal result. Nothing is removed again.",
} as const;

const plural = (count: number, one: string, many: string) => `${count} ${count === 1 ? one : many}`;

export const teachingText = {
  crn: (crn: string) => `CRN ${crn}`,
  sections: (count: number) => plural(count, "course", "courses"),
  mayTeach: (name: string) => `${name.trim().split(/\s+/)[0] || "This person"} may teach but has no profile.`,
  refer: (count: number) => `${plural(count, "course refers", "courses refer")} to it`,
  clearFirst: (count: number) => `Keep this profile for ${plural(count, "course", "courses")}. Use Archive person to remove them from working lists.`,
};
